import { atom } from "recoil";

export const deviceTagModalLoadingAtom = atom<boolean | undefined>({
  key: "deviceTagModalLoadingAtom",
  default: undefined,
});

export const assignedDeviceTagErrorAtom = atom<string | undefined>({
  key: "assignedDeviceTagErrorAtom",
  default: undefined,
});
